import React, { createContext } from 'react'

import { useQuery } from '@/api'
import { DEFAULT_CONTEXT_VALUES, PRODUCTIONS_ENDPOINT } from '@/constants'

import { licensesSelector } from './selectors'
import type {
    LicensesContextType,
    LicensesProviderProps,
    LicensesResponse,
    LicensesSelectorType,
    LicensesStateType,
} from './types'

const LicensesContext = createContext<LicensesContextType>(DEFAULT_CONTEXT_VALUES)
const { Provider } = LicensesContext

const getLicensesEndpoint = (productionId: number): string => `${PRODUCTIONS_ENDPOINT}/${productionId}/licenses`

export const ProductionLicensesProvider: React.FC<LicensesProviderProps> = ({ children, initialParams }) => {
    const { id, ...queryParams } = initialParams
    const endpoint = getLicensesEndpoint(id)

    const { fetching, data, error } = useQuery<LicensesResponse>({
        endpoint,
        params: queryParams,
        initialFetchDisabled: true,
    })

    const state: LicensesStateType = { fetching, data, error }

    const selectors: LicensesSelectorType = { licenses: licensesSelector(state) }

    return <Provider value={{ state, selectors }}>{children}</Provider>
}

export default LicensesContext
